import { dataBarChartSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBarChartSquareSolid = /*#__PURE__*/createIcon(dataBarChartSquareSolid)
export default IconBarChartSquareSolid
